/**
 * Get Bounded Context Handler
 * 
 * CQRS Query Handler that delegates to BoundedContextQueryService.
 * Thin adapter layer for read operations.
 */

import { injectable, inject } from 'inversify';
import { DDD_SYMBOLS } from '../../../../infrastructure/di/DDD_SYMBOLS';
import { IQueryHandler } from '@swoft/core';
import { GetBoundedContextQuery, BoundedContextDto } from '../queries/GetBoundedContextQuery';
import { BoundedContextQueryService } from '../services/BoundedContextQueryService';

@injectable()
export class GetBoundedContextHandler implements IQueryHandler<GetBoundedContextQuery, BoundedContextDto | null> {
  constructor(
    @inject(DDD_SYMBOLS.BoundedContextQueryService) private boundedContextQueryService: BoundedContextQueryService
  ) {}

  async handle(query: GetBoundedContextQuery): Promise<BoundedContextDto | null> {
    const boundedContextDto = await this.boundedContextQueryService.getBoundedContext(
      query.domainId,
      query.contextId
    );
    
    if (!boundedContextDto) {
      throw new Error(`Bounded context with ID ${query.contextId} not found`);
    }

    return boundedContextDto;
  }
}